<template>
  <div class="cover" :style="{backgroundImage: `url(${topImg})`}">
    <div class="cover-content type-center white-color align-right">
      <div class="f54 fB400" v-if="configs.website_title">
        {{ $i18n.locale == 'zh' ? configs.website_title.zhVal : configs.website_title.enVal }}
      </div>
      <div class="mtb25" v-if="configs.website_slogan">
        {{ $i18n.locale == 'zh' ? configs.website_slogan.zhVal : configs.website_slogan.enVal }}
      </div>
      <div class="cover-link floatRight"/>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "Cover",
  props: {
    topImg: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['configs']),
  },
  watch: {},
  data() {
    return {
      backgroundImage: ''
    };
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.cover {
  //background-image: url('../../assets/image/home/topImg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 1080px;
  width: 100%;

  &-content {
    padding-top: 347px;
    font-size: 36px;
    font-weight: 300;
  }

  &-link {
    width: 207px;
    height: 4px;
    background: #FFFFFF;
  }
}
</style>
